<template>
  <label class="rr-switch">
    <input
      class="rr-switch__input"
      :type="type"
      :disabled="disabled"
      :value="value"
      v-model="proxyChecked"
    />
    <span class="rr-switch__marker">
      <svg
        class="rr-switch__marker-icon"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        id="icon-check-bold"
      >
        <path
          fill-rule="evenodd"
          d="M8.115 19.748a1.792 1.792 0 002.917 0l11.883-16.53c.214-.3 0-.718-.367-.718h-2.646c-.576 0-1.123.277-1.462.753l-8.863 12.34-4.017-5.592a1.803 1.803 0 00-1.462-.753H1.452a.455.455 0 00-.367.719l7.03 9.781z"
          clip-rule="evenodd"
        ></path>
      </svg>
      <svg class="rr-switch__marker-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path
          fill-rule="evenodd"
          d="M13.649 12l8.29-9.598c.14-.16.023-.402-.192-.402h-2.52a.521.521 0 00-.389.175L12 10.092 5.162 2.175A.51.51 0 004.773 2h-2.52c-.215 0-.332.242-.193.402L10.351 12l-8.29 9.598a.238.238 0 00-.037.261c.041.086.13.141.229.141h2.52c.149 0 .291-.064.389-.175L12 13.908l6.838 7.917c.095.11.237.175.389.175h2.52c.215 0 .332-.242.193-.402L13.649 12z"
          clip-rule="evenodd"
        ></path>
      </svg>
    </span>
  </label>
</template>

<script>
/* eslint-disable */
export default {
  name: "RrSwitch",
  props: {
    /**
     * Атрибут disabled для инпута.
     */
    disabled: {
      type: Boolean,
      default: false,
    },
    /**
     * Атрибут type для инпута.
     * `checkbox, radio`
     */
    type: {
      type: String,
      default: "checkbox",
      validator: value => {
        return value.match(/(checkbox|radio)/)
      },
    },
    /**
     * Значение v-model.<br>
     * Тип `boolean` для одного свитча.<br>
     * Тип `array, number, string` для группы свитчей.<br>
     */
    checked: {
      type: [Array, Boolean, Number, String],
      default: false,
    },
    /**
     * Атрибут value для инпута. Используется в группе свитчей.
     */
    value: {
      type: [String, Number],
      default: null,
    },
  },
  model: {
    prop: "checked",
    event: "change",
  },
  computed: {
    proxyChecked: {
      get() {
        return this.checked
      },
      set(val) {
        this.$emit("change", val)
      },
    },
  },
}
</script>

<style lang="scss" scoped>
$switch-border-radius: 4px;

*,
::before,
::after {
  box-sizing: border-box;
}

.rr-switch {
  display: inline-flex;
  vertical-align: middle;
  align-items: center;
  position: relative;

  &__input,
  &__marker {
    width: 48px;
    height: 24px;
  }

  &__input {
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
    margin: 0;
    z-index: 1;
    cursor: pointer;

    &:disabled {
      cursor: not-allowed;
    }
  }

  &__marker {
    background-color: map-get($color-neutral-black, 45);
    border-radius: $switch-border-radius + 1;
    position: relative;
    color: #fff;
    transition: 0.2s ease-in-out;
    user-select: none;

    &::after {
      content: "";
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      background-color: #fff;
      border-radius: $switch-border-radius;
      width: 20px;
      height: 20px;
      margin: 2px;
      box-shadow: $elevation-deth-4;
      transition: 0.2s ease-in-out;
      transform-origin: top left;
    }

    .rr-switch__input:checked ~ & {
      background-color: $color-success;

      &::after {
        transform: translateX(120%);
        transform-origin: top right;
      }
    }

    .rr-switch__input:active ~ &::after {
      transition-delay: 0.05s;
      transform: scaleX(1.2);
    }

    .rr-switch__input:active:checked ~ &::after {
      transform: translateX(120%) scaleX(1.2);
    }

    .rr-switch__input:disabled ~ & {
      background-color: map-get($color-neutral-black, 25);
    }

    .rr-switch__input:disabled:checked ~ & {
      background-color: rgba($color-success, 0.45);
    }
  }

  &__marker-icon {
    position: absolute;
    top: 50%;
    left: 0;
    fill: currentColor;
    width: 50%;
    height: 12px;
    margin: -6px 1px 0;
    transition: 0.2s ease-in-out;
    transition-delay: 0.05s;
    transform-origin: center;

    &:first-child {
      transform: scale(0.5);
    }

    &:last-child {
      left: auto;
      right: 0;
    }

    .rr-switch__input:checked ~ .rr-switch__marker & {
      &:first-child {
        transform: scale(1);
      }

      &:last-child {
        transform: scale(0.5);
      }
    }
  }
}
</style>
